export default __webpack_public_path__ + "static/media/imagez.56be0139.PNG";